import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/ui/button/button';
import { Link } from 'react-router-dom';
import { appRoutes } from 'src/routes/routes.types';
import { CirclePlus, Loader2, Settings2 } from 'lucide-react';
import { subscriptionClient } from 'src/lib/services/api/subscription-api';
import { AxiosRequestConfig } from 'axios';

type Props = ComponentProps<typeof Button>;

export const openBillingPortal = async (config?: AxiosRequestConfig) => {
  const res = await subscriptionClient.createBillingPortalSession(window.location.href, config);
  window.location.href = res.url;
};

const CreateSubscriptionButton: React.FC<Props> = (props) => {
  const { t } = useTranslation('actions');
  const [manageLoading, setManageLoading] = React.useState(false);

  const handleManageClick = async () => {
    setManageLoading(true);
    await openBillingPortal().catch(() => {
      // Only reset loading state if the request fails to keep loading till user is navigated to the billing portal
      setManageLoading(false);
    });
  };

  return (
    <div className={'tw-flex tw-items-center tw-gap-2'}>
      <Button variant={'brand'} size={'small'} asChild {...props}>
        <Link className="tw-gap-1" to={appRoutes.addSubscriptionPlanSelect}>
          <CirclePlus className={'tw-size-4'} />
          {t('common:add_new', {
            defaultValue: 'Add new',
          })}
        </Link>
      </Button>
      <Button
        className="tw-gap-1"
        onClick={handleManageClick}
        variant={'brand'}
        size={'small'}
        disabled={manageLoading}
      >
        {manageLoading ? (
          <Loader2 className="tw-size-4 tw-animate-spin" />
        ) : (
          <Settings2 className={'tw-size-4'} />
        )}
        {t('common:manage', {
          defaultValue: 'Manage',
        })}
      </Button>
    </div>
  );
};

export { CreateSubscriptionButton };
